export var version = '3.4.17';
//# sourceMappingURL=version.js.map